"use client";

import { NotificationItemLayout, type NotificationItemProps } from "./layout";
import { useNotificationItem } from "./use-notification-item";

export function ReplyNotificationItem({ notification }: NotificationItemProps) {
  const item = useNotificationItem(notification);

  return (
    <NotificationItemLayout.Container
      hasTargetUrl={Boolean(item.actionUrl)}
      isUnread={item.isUnread}
      onActivate={item.handleActivate}
      onMarkRead={item.handleMarkRead}
      onMarkUnread={item.handleMarkUnread}
    >
      <NotificationItemLayout.Media
        actor={item.actor}
        iconName="IconBubbleDots"
        iconStyle="bg-blue-500 text-white"
      />
      <NotificationItemLayout.Content>
        <NotificationItemLayout.Title isUnread={item.isUnread}>
          {notification.title}
        </NotificationItemLayout.Title>
        <NotificationItemLayout.Time>
          {item.relativeCreatedAt}
        </NotificationItemLayout.Time>
        {item.previewText && (
          <NotificationItemLayout.Body>
            {item.previewText}
          </NotificationItemLayout.Body>
        )}
      </NotificationItemLayout.Content>
    </NotificationItemLayout.Container>
  );
}
